export enum ECommonError {
  RESPONSE_NOT_VALID = 'Response is not valid',
}
